"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.radioboxStyles = exports.radioInnerCircle = exports.labelStyles = void 0;

var _reactEmotion = require("react-emotion");

var _styleConsts = require("../utils/styleConsts");

var radioCircleHover = function radioCircleHover(theme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("&::before{content:'';display:inline-block;position:absolute;width:25px;height:25px;background-color:", theme.color.dark.white0_12, ";transition:0.5s ease;border-radius:50%;top:50%;left:50%;transform:translate(-50%,-50%);}")
  );
};

var labelStyles = function labelStyles(theme, disabled) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("font-size:", _styleConsts.font.size.medium, ";color:", theme.color.dark.copper, ";background:transparent;font-weight:normal;font-style:normal;font-stretch:normal;line-height:1.36;letter-spacing:normal;display:flex;align-items:center;cursor:pointer;", disabled &&
    /*#__PURE__*/
    (0, _reactEmotion.css)("cursor:not-allowed;"), ";&:hover div{", !disabled && radioCircleHover(theme), ";}input{", _styleConsts.screenReaderOnly, "}input:hover ~ span{color:", theme.color.dark.amethyst, ";}input:checked ~ span{color:", theme.color.dark.amethyst, ";}input:checked ~ div{position:relative;}input:checked ~ div{border-color:", theme.color.dark.amethyst, ";position:relative;span{background-color:", theme.color.dark.amethyst, ";}}input:disabled ~ span{opacity:", theme.color.dark.disabledOpacity, ";color:", theme.color.dark.nickel, ";}input:disabled ~ div{opacity:", theme.color.dark.disabledOpacity, ";border:1px solid ", theme.color.dark.nickel, ";}")
  );
};

exports.labelStyles = labelStyles;

var radioInnerCircle = function radioInnerCircle() {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("width:8px;height:8px;border-radius:50%;background-color:transparent;transition:background-color 0.25s;")
  );
};

exports.radioInnerCircle = radioInnerCircle;
var alignItems =
/*#__PURE__*/
(0, _reactEmotion.css)("display:inline-flex;justify-content:center;align-items:center;");

var radioboxStyles = function radioboxStyles(theme, disabled) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)(alignItems, ";position:relative;box-sizing:border-box;min-width:14px;max-width:14px;width:14px;height:14px;border:1px solid ", theme.color.dark.iron, ";border-radius:50%;transition:border-color 0.25s;background-color:transparent;margin-right:8px;&:hover{", !disabled && radioCircleHover(theme), ";}")
  );
};

exports.radioboxStyles = radioboxStyles;